import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Calendar} from "primereact/calendar";
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputMask} from "primereact/inputmask";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";
import {Panel} from "primereact/panel";

import moment from "moment/moment";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {InputNumber} from "primereact/inputnumber";

const ScheduleFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity} = useParams();
  const [loading, setLoading] = useState(false);
  const [machines, setMachines] = useState([]);
  const [formData, setFormData] = useState({
    schedule_group: window.App.urlVars().schedulegroupId,
    break_minutes: 0,
  });
  const isMachineEmployeeCapacity = window.App.urlVars().schedulegroupType === 'MACHINE_EMPLOYEE_CAPACITY'
  const [draggingEmployeeIds, setDraggingEmployeeIds] = useState([]);
  const [dragOverEmployeesTarget, setDragOverEmployeesTarget] = useState(false);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [filtersEmployeesTarget, setFiltersEmployeesTarget] = useState({
    name: { value: null, matchMode: 'contains' }
  });

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    const basePayload = {
      ...data,
      ...formData
    };
    let _data
    if (isMachineEmployeeCapacity) {
      const employeesWithMachines = employeesToAdd.map(emp => ({
        id: emp.id,
        machine: emp.selected_machine || null
      }));

      _data = {
        ...basePayload,
        employees: employeesWithMachines
      };
    } else if (window.App.urlVars().schedulegroupType === 'EMPLOYEE_CAPACITY') {
      let employeeIds = []
      employeesToAdd.map(function (item, index) {
        employeeIds.push(item.id)
      })
      _data = {
        ...basePayload,
        employees: employeeIds
      }
    } else {
      _data = basePayload
    }
    setLoading(true)
    apiCall('post', '/api/v2/schedule/new/batch', _data)
      .then(response => {
        window.App.toastShow('success', 'Sikeres mentés!');
        window.App.setState({rerenderScheduleList: Math.random()})
        if (props.goback === true) {
          history.push(props.backlink);
        }
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setLoading(false);
      })
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  // employees
  const [employeesSource, setEmployeesSource] = useState([]);
  const [employeesToAdd, setEmployeesToAdd] = useState([]);
  // const [employeesTarget, setEmployeesTarget] = useState([]);
  // const [employeesToDelete, setEmployeesToDelete] = useState([]);

  const [loadingEmployeesSource, setLoadingEmployeesSource] = useState(false);
  const [totalRecordsEmployeesSource, setTotalRecordsEmployeesSource] = useState(0);
  const [rowsEmployeesSource, setRowsEmployeesSource] = useState(10);
  const [lazyParamsEmployeesSource, setLazyParamsEmployeesSource] = useState({
    first: 0,
    rows: rowsEmployeesSource,
    page: 0,
    sortField: 'id',
    sortOrder: -1
  });
  let loadLazyTimeoutEmployeesSource = null;
  const loadLazyDataEmployeesSource = (worktypeId) => {
    setLoadingEmployeesSource(true);
    if (loadLazyTimeoutEmployeesSource) {
      clearTimeout(loadLazyTimeoutEmployeesSource);
    }
    loadLazyTimeoutEmployeesSource = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParamsEmployeesSource)
      apiCall('get', '/api/v2/employee' + query + '&search[active][operator]==&search[active][value]=true')
        .then(response => {
          setTotalRecordsEmployeesSource(response.data.data.total_item_count);
          setEmployeesSource(response.data.data.items);
          setLoadingEmployeesSource(false);
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPageEmployeesSource = (event) => {
    let _lazyParams = {...lazyParamsEmployeesSource, ...event};
    setLazyParamsEmployeesSource(_lazyParams);
  }
  const onSortEmployeesSource = (event) => {
    let _lazyParams = {...lazyParamsEmployeesSource, ...event};
    setLazyParamsEmployeesSource(_lazyParams);
  }
  const onFilterEmployeesSource = (event) => {
    let _lazyParams = {...lazyParamsEmployeesSource, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParamsEmployeesSource(_lazyParams);
  }
  const pagerEmployeesSource = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions}
                    onChange={(e) => setRowsEmployeesSource(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  useEffect(() => {
    loadLazyDataEmployeesSource();
  }, [lazyParamsEmployeesSource])

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const handleDragStart = (event, item) => {
    let draggedItems = [item];
    if (Array.isArray(selectedEmployees) && selectedEmployees.length > 0) {
      const isPartOfSelection = selectedEmployees.some(sel => sel.id === item.id);
      if (isPartOfSelection) {
        draggedItems = selectedEmployees;
      }
    }
    const draggedIds = draggedItems.map(i => i.id);
    const payload = {
      source: 'employeesSource',
      ids: draggedIds
    };
    setDraggingEmployeeIds(draggedIds);
    event.dataTransfer.setData("application/json", JSON.stringify(payload));
    event.dataTransfer.effectAllowed = 'move';
  };

  const handleDragEnd = () => {
    setDraggingEmployeeIds([]);
    setDragOverEmployeesTarget(false);
  };

  const handleDrop = (event, target) => {
    event.preventDefault();
    setDragOverEmployeesTarget(false);
    if (target !== "right") return;
    let payload = null;
    const raw =
      event.dataTransfer.getData("application/json") ||
      event.dataTransfer.getData("text/plain");
    if (!raw) return;
    try {
      payload = JSON.parse(raw);
    } catch (error) {
      return;
    }
    let ids = [];
    if (payload && Array.isArray(payload.ids)) {
      ids = payload.ids;
    } else if (payload && payload.id) {
      ids = [payload.id];
    } else if (Array.isArray(payload)) {
      ids = payload;
    }
    if (!ids || ids.length === 0) return;
    const itemsToAddRaw = employeesSource.filter(item => ids.includes(item.id));
    if (itemsToAddRaw.length === 0) return;
    const hasAlreadyAddedEmployee = itemsToAddRaw.some(item =>
      employeesToAdd.some(emp => emp.id === item.id)
    );
    if (hasAlreadyAddedEmployee) {
      const confirmed = window.confirm(
        'A munkavállaló már szerepel a műszakban, biztosan kétszer is hozzáadod?'
      );
      if (!confirmed) {
        setSelectedEmployees([]);
        setDraggingEmployeeIds([]);
        return;
      }
    }
    const itemsToAdd = itemsToAddRaw.map((item, index) => ({
      ...item,
      rowKey: `${item.id}-${Date.now()}-${index}-${Math.random()}`,
      selected_machine: item.selected_machine || null
    }));
    setEmployeesToAdd(prev => [
      ...prev,
      ...itemsToAdd
    ]);
    setSelectedEmployees([]);
    setDraggingEmployeeIds([]);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const renderDraggableCell = (rowData, content) => (
    <div
      draggable
      style={{ cursor: 'move' }}
      onDragStart={(e) => handleDragStart(e, rowData)}
      onDragEnd={handleDragEnd}
    >
      {content}
    </div>
  );

  const removeEmployeeFromTarget = (rowData) => {
    setEmployeesToAdd(prev => prev.filter(emp => emp.rowKey !== rowData.rowKey));
  };

  const machineOptions = [
    ...machines.map(m => ({ label: m.name, value: m.id }))
  ];

  const onMachineChange = (rowData, value) => {
    setEmployeesToAdd(prev =>
      prev.map(emp =>
        emp.rowKey === rowData.rowKey
          ? { ...emp, selected_machine: value }
          : emp
      )
    );
  };

  const machineBodyTemplate = (rowData) => {
    return (
      <Dropdown 
        value={rowData.selected_machine || null} 
        options={machineOptions} 
        onChange={(e) => onMachineChange(rowData, e.value)} 
        placeholder={t('selectPlaceholder')}className="p-fluid"
        pt={{
          item: ({ context }) => ({
            style: context.selected || context.focused 
              ? { backgroundColor: '#ffffff', color: '#000000' } 
              : {}
          })
        }}
      />
    );
  };

  useEffect(() => {
    axios.get(process.env.REACT_APP_API_HOST + '/api/v2/machine', {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
      .then(response => {
        const sortedMachines = response.data.data.items.sort((a, b) => 
            a.name.localeCompare(b.name, 'hu')
        );
        setMachines(sortedMachines);
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      })
  }, [])

  return (
    <div className={"action-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="" 
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  const tagName = e.target?.tagName?.toLowerCase();
                  const isInputActive = tagName === 'input' || tagName === 'textarea';

                  if (isInputActive) {
                    e.preventDefault();
                  }
                }
              }}
            >
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-3"}>
              <Field name="date_from" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="date_from"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldDateFrom')}</label>
                  <span className="">
                          <div className="p-inputgroup calendar-icon-only">
                            <InputMask id={"date_from"}
                                       mask={"9999-99-99"}
                                       placeholder={t('datePlaceholder')}
                                       value={formData.date_from}
                                       onChange={(e) => {
                                         if (e.value.indexOf("_") === -1) {
                                           if (e.value === '') {
                                             e.value = null
                                           }
                                           setFormData({
                                             ...formData,
                                             date_from: e.value
                                           })
                                         }
                                       }}
                            />
                            <Calendar value={formData.date_from}
                                      locale="hu"
                                      format={'yy-mm-dd'}
                                      showIcon
                                      onChange={(e) => {
                                        setFormData({
                                          ...formData,
                                          date_from: moment.utc(e.value).local().format('YYYY-MM-DD')
                                        })
                                      }}/>
                          </div>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-3"}>
              <Field name="date_to" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="date_to"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldDateTo')}</label>
                  <span className="">
                          <div className="p-inputgroup calendar-icon-only">
                          <InputMask id={"date_to"}
                                     mask={"9999-99-99"}
                                     placeholder={t('datePlaceholder')}
                                     value={formData.date_to}
                                     onChange={(e) => {
                                       if (e.value.indexOf("_") === -1) {
                                         if (e.value === '') {
                                           e.value = null
                                         }
                                         setFormData({
                                           ...formData,
                                           date_to: e.value
                                         })
                                       }
                                     }}
                          />
                            <Calendar value={formData.date_to}
                                      locale="hu"
                                      format={'yy-mm-dd'}
                                      showIcon
                                      onChange={(e) => {
                                        setFormData({
                                          ...formData,
                                          date_to: moment.utc(e.value).local().format('YYYY-MM-DD')
                                        })
                                      }}/>
                          </div>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-3"}>
              <Field name="time_from" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="time_from"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldTimeFrom')}</label>
                  <span className={"p-d-block"}>
                          <InputMask id={"time_from"}
                                     mask={"99:99"}
                                     placeholder={t('timePlaceholder')}
                                     value={formData.time_from}
                                     onChange={(e) => {
                                       if (e.value.indexOf("_") === -1) {
                                         if (e.value === '') {
                                           e.value = null
                                         }
                                         setFormData({
                                           ...formData,
                                           time_from: e.value
                                         })
                                       }
                                     }}
                          />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-3"}>
              <Field name="time_to" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="time_to"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldTimeTo')}</label>
                  <span className={"p-d-block"}>
                          <InputMask id={"time_to"}
                                     mask={"99:99"}
                                     placeholder={t('timePlaceholder')}
                                     value={formData.time_to}
                                     onChange={(e) => {
                                       if (e.value.indexOf("_") === -1) {
                                         if (e.value === '') {
                                           e.value = null
                                         }
                                         setFormData({
                                           ...formData,
                                           time_to: e.value
                                         })
                                       }
                                     }}
                          />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-3"}>
              <Field name="break_minutes" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="break_minutes"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{t('fieldBreakMinutes')}</label>
                  <span className="p-d-block">
                    <InputNumber
                      id="break_minutes"
                      min={0}
                      minFractionDigits={0}
                      maxFractionDigits={0}
                      locale="hu-HU"
                      value={formData.break_minutes ?? 0}
                      onValueChange={(e) => {
                        setFormData({
                          ...formData,
                          break_minutes: e.value ?? 0
                        })
                      }}
                      className={classNames({'p-invalid': isFormFieldValid(meta)})}
                    />
                  </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          {window.App.urlVars().schedulegroupType === 'EMPLOYEE_CAPACITY' || isMachineEmployeeCapacity ? (
            <div className="p-grid">
              <div
                className="p-col-12 p-lg-6"
                onDragOver={handleDragOver}
              >
                <Panel>
                  <div className="p-grid">
                    <div className="p-col-12 p-col-align-center p-text-center p-text-lg-left">
                      <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
                        Munkavállalók
                      </h3>
                    </div>
                  </div>

                  <DataTable
                    size={localStorage.getItem('scale')}
                    emptyMessage={t('noResults')}
                    value={employeesSource}
                    paginator
                    first={lazyParamsEmployeesSource.first}
                    totalRecords={totalRecordsEmployeesSource}
                    onPage={onPageEmployeesSource}
                    onSort={onSortEmployeesSource}
                    sortField={lazyParamsEmployeesSource.sortField}
                    sortOrder={lazyParamsEmployeesSource.sortOrder}
                    onFilter={onFilterEmployeesSource}
                    filters={lazyParamsEmployeesSource.filters}
                    loading={loadingEmployeesSource}
                    lazy
                    paginatorTemplate={pagerEmployeesSource}
                    rows={rowsEmployeesSource}
                    autoLayout={true}
                    selection={selectedEmployees}
                    onSelectionChange={(e) => setSelectedEmployees(e.value)}
                    dataKey="id"
                    filterDisplay="row"
                    responsiveLayout="scroll"
                    stripedRows
                    rowClassName={(rowData) =>
                      Array.isArray(draggingEmployeeIds) && draggingEmployeeIds.includes(rowData.id)
                        ? 'dnd-drag-source-row-active'
                        : 'dnd-drag-source-row'
                    }
                  >
                    <Column
                      selectionMode="multiple"
                      headerStyle={{ width: '3rem' }}
                    />

                    <Column field="name" header={t('columnName2')} sortable filter
                      body={(rowData) =>
                        renderDraggableCell(rowData, rowData?.name || '-')
                      }
                    />

                    <Column field="birth_day" header={t('columnDateOfBirth')} sortable
                      body={(rowData) =>
                        renderDraggableCell(
                          rowData,
                          rowData?.birth_day
                            ? window.App.formatDateValue(rowData.birth_day)
                            : '-'
                        )
                      }
                    />
                  </DataTable>
                </Panel>
              </div>

              <div
                className="p-col-12 p-lg-6"
                onDragOver={(e) => {
                  e.preventDefault();
                  if (draggingEmployeeIds.length > 0) {
                    setDragOverEmployeesTarget(true);
                  }
                }}
                onDragLeave={(e) => {
                  const related = e.relatedTarget;
                  if (!e.currentTarget.contains(related)) {
                    setDragOverEmployeesTarget(false);
                  }
                }}
                onDrop={(e) => handleDrop(e, "right")}
              >
                <Panel>
                  <div className="p-grid">
                    <div className="p-col-12 p-col-align-center p-text-center p-text-lg-left">
                      <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
                        Beosztott munkavállalók
                      </h3>
                    </div>
                  </div>

                  <div
                    className={dragOverEmployeesTarget ? 'dnd-drop-zone-active' : ''}
                    style={{
                      minHeight: '120px'
                    }}
                  >
                    <DataTable
                      size={localStorage.getItem('scale')}
                      value={employeesToAdd}
                      dataKey="rowKey"
                      autoLayout={true}
                      responsiveLayout="scroll"
                      stripedRows
                      filterDisplay="row"
                      filters={filtersEmployeesTarget}
                      onFilter={(e) => setFiltersEmployeesTarget(e.filters)}
                    >
                      <Column field="name" header={t('columnName2')} sortable filter body={(rowData) => rowData?.name || '-'}/>

                      <Column field="birth_day" header={t('columnDateOfBirth')}
                        body={(rowData) =>
                          rowData?.birth_day
                            ? window.App.formatDateValue(rowData.birth_day)
                            : '-'
                        }
                      />

                      {isMachineEmployeeCapacity && (
                        <Column
                          header={t('columnMachine')}
                          body={machineBodyTemplate}
                          style={{ minWidth: '220px' }}
                        />
                      )}

                      <Column header=""
                        body={(rowData) => (
                          <Button
                            type="button"
                            icon="pi pi-trash"
                            className="p-button-danger p-button-sm"
                            onClick={() => removeEmployeeFromTarget(rowData)}
                            tooltip="Eltávolítás"
                          />
                        )}
                        style={{ width: '4rem', textAlign: 'center' }}
                      />
                    </DataTable>
                  </div>
                </Panel>
              </div>
            </div>
          ) : (
            <>
            {!isMachineEmployeeCapacity && (
              <>
                <div className={"p-grid"}>
                  <div className={"p-col-12"}>
                    <h3 className={""}>
                      <i className={"pi pi-list"}></i> {props.t('numberOfCycles')}
                    </h3>
                  </div>
                </div>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6"}>
                    <Field name="count" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                        <label htmlFor="count"
                              className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCount')}</label>
                        <span className="p-d-block">
                                <InputNumber id="count" {...input}
                                            minFractionDigits={0}
                                            maxFractionDigits={9}
                                            locale="hu-HU"
                                            onValueChange={(e) => {
                                              setFormData({
                                                ...formData,
                                                count: e.value
                                              })
                                            }}
                                            value={formData.count}
                                            className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                              </span>
                        {getFormErrorMessage(meta)}
                      </div>
                    )}/>
                  </div>
                </div>
                </>
              )}
            </>
          )}
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'schedule-group' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        disabled={
                          (window.App.urlVars().schedulegroupType === 'EMPLOYEE_CAPACITY' || isMachineEmployeeCapacity)
                          && employeesToAdd.length === 0
                        }
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      disabled={
                        (window.App.urlVars().schedulegroupType === 'EMPLOYEE_CAPACITY' || isMachineEmployeeCapacity)
                        && employeesToAdd.length === 0
                      }
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(ScheduleFormComponent);
